import React from 'react'
import { FontIcon, TableColumn, TableHeader, TableRow } from 'react-md'

const tooltipText = {
  'size': 'The available sizes are determined by your artwork file size.',
  'base-price': `This is our base price taking into account the cost of
    printing, framing and fulfilment.`,
  'markup': 'This is the amount you will make per sale.',
  'retail-price': `This is the final retail price that your customers will pay.
    Please note, it includes 20% VAT as per European Law.
    <br /><br />This value is calculated as follows: (Base Price + Markup) x 1.2.`
}

const ListHeader = ({ onHelpMessage }) => (
  <TableHeader>
    <TableRow>
      <TableColumn grow>
        <div className='commission-container'>
          <span className='commission-text'>Available Sizes</span>
          <FontIcon
            forceSize={15}
            forceFontSize
            onClick={() => onHelpMessage(tooltipText['size'])}
          >
            info
          </FontIcon>
        </div>
      </TableColumn>
      <TableColumn numeric>
        <div className='commission-container'>
          <span className='commission-text'>Base Price</span>
          <FontIcon
            forceSize={15}
            forceFontSize
            onClick={() => onHelpMessage(tooltipText['base-price'])}
          >
            info
          </FontIcon>
        </div>
      </TableColumn>
      <TableColumn>
        <div className='commission-container'>
          <span className='commission-text'>Markup</span>
          <FontIcon
            forceSize={15}
            forceFontSize
            onClick={() => onHelpMessage(tooltipText['markup'])}
          >
            info
          </FontIcon>
        </div>
      </TableColumn>
      <TableColumn numeric>
        <div className='commission-container'>
          <span className='commission-text'>Retail Price</span>
          <FontIcon
            forceSize={15}
            forceFontSize
            onClick={() => onHelpMessage(tooltipText['retail-price'])}
          >
            info
          </FontIcon>
        </div>
      </TableColumn>
    </TableRow>
  </TableHeader>
)

export default ListHeader



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/CommissionsView/CommissionList/ListHeader.js